import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const NotFound: React.FC = () => {
    return (
        <div className="not-found-container">
            <h1>404</h1>
            <h2>페이지를 찾을 수 없습니다</h2>
            <p>죄송합니다. 요청하신 페이지를 찾을 수 없습니다.</p>
            <Link to="/" className="home-button">홈으로 돌아가기</Link>
        </div>
    );
};

export default NotFound;